import * as React from "react";

const BadgeAvailableToShip: React.FC = () => {
    return (
        <svg
            width="16px"
            height="17px"
            viewBox="0 0 16 17"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <path
                    fill="currentColor"
                    d="M7.99999964,16.5001 C10.8581247,16.5001 13.4991407,14.9753083 14.9282036,12.5001 C16.3572655,10.0248917 16.3572655,6.97530876 14.9282036,4.5001 C13.4991407,2.02489172 10.8581247,0.5001 7.99999964,0.5001 C5.14187527,0.5001 2.50085878,2.02489172 1.07179642,4.5001 C-0.357265949,6.97530876 -0.357265949,10.0248917 1.07179642,12.5001 C2.50085878,14.9753083 5.14187527,16.5001 7.99999964,16.5001 Z M7.53125,11.03135 L7,11.5626 L6.46875,11.03135 L3.96875,8.53135 L5.03125,7.46885 L7,9.4376 L10.96875,5.46885 L12.03125,6.53135 L7.53125,11.03135 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(BadgeAvailableToShip);
